import * as Chart from 'chart.js';

Chart.defaults.global.defaultFontSize = 11;
Chart.defaults.global.defaultFontFamily = '"Inter", sans-serif';
